import { extract, EventAggregator } from "@parksandresorts/core";
import InteractionHelper from "components/helpers/interaction-helper";
import PropTypes from "prop-types";
import { createRef, Component } from "react";
import styles from "./parallax.module.less";
//import EventAttributeStore from 'components/stores/event-attribute-store';

export default class Parallax extends Component {
  static propTypes = {
    parallaxOffset: PropTypes.number,
  };

  static defaultProps = {};

  constructor(props) {
    super(props);
    this.ref_parallax = createRef();
    this.parallaxOffset = extract(props, "parallaxOffset");
  }

  componentDidMount() {
    this.onScrollSubcription = EventAggregator.subscribe("onScroll", this.onScroll);
    this.onScroll(0);
  }

  componentWillUnmount() {
    if (this.onScrollSubcription) {
      this.onScrollSubcription.remove();
    }
  }

  onScroll = (yPos) => {
    if (typeof this.parallaxOffset === "number") {
      yPos = yPos - this.parallaxOffset;
    }
    if (yPos <= 0) {
      yPos = 0;
    }
    if (this.isInScreen()) {
      //const parallaxValue = (this.ref_parallax.current.getBoundingClientRect().top / EventAttributeStore.getCurrentWindowHeight()) * this.ref_parallax.current.clientHeight;
      this.setTransform3d(this.ref_parallax.current, "0", `${Math.round(yPos / 3)}px`, "0");
    }
  };

  isInScreen() {
    if (this.ref_parallax && this.ref_parallax.current) {
      return InteractionHelper.isInScreen(this.ref_parallax.current);
    }

    return false;
  }

  setTransform3d(el, x = 0, y = 0, z = 0) {
    const transform = `translate3d(${x}, ${y}, ${z})`;
    el.style.WebkitTransform = transform;
    el.style.MozTransform = transform;
    el.style.OTransform = transform;
    el.style.msTransform = transform;
    el.style.transform = transform;
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <div ref={this.ref_parallax} className={styles.parallax}>
          {this.props.children}
        </div>
      </div>
    );
  }
}
